import { ListStationsResponse, StationWeekList } from '@/Network/Types/Responses/StationResponses'
import {
  Content,
  ContentText,
  TDocumentDefinitions,
  TableCell,
  Alignment
} from 'pdfmake/interfaces'
import { startOfWeek, endOfWeek, addDays, format } from 'date-fns'
import { COVERAGE_STATUS_SHORT_LABELS, isUnidentifiedCoverage } from '@/utils/coverage'
import { CoverageStatus } from '@/Network/Types/Responses/CoverageResponses'
import { UNIDENTIFIED_COVERAGE_COLORS } from '@/components/designSystem/Table/StandardRow/unidentifiedCoverageStyles'

const img64 =
  'data:image/PNG;base64,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'

const dateFormat = 'dd/MM/yy'

// Altura Fixa do Card
const FIXED_CARD_HEIGHT = 45
// Altura média estimada de uma linha de texto (Fonte 9)
const ESTIMATED_LINE_HEIGHT = 10

export interface WeekData {
  weekStartDate: string
  responseData: ListStationsResponse
}

type CardType = TableCell

const getFirstAndLastName = (fullName: string = ''): string => {
  if (!fullName || typeof fullName !== 'string') return ''
  const parts = fullName.trim().split(/\s+/)
  if (parts.length === 0) return ''
  return `${parts[0]} ${parts.length > 1 ? parts[parts.length - 1] : ''}`.trim()
}

const getStyleClass = (type: 'FIXO' | 'ABERTO' | 'COBERTURA' | 'EXTRA' | undefined): string => {
  const styleMap = {
    FIXO: 'weeklyCard',
    COBERTURA: 'coverageCard',
    EXTRA: 'extraCard',
    ABERTO: 'openedCard'
  }
  if (!type) return 'defaultCard'
  return styleMap[type] || 'defaultCard'
}

const getFirstItemTopMargin = (margin: unknown): number => {
  if (!margin) return 0
  return Array.isArray(margin) ? (margin as number[])[1] : (margin as number)
}

/**
 * Função Auxiliar para calcular Margem Superior
 * Isso força a centralização vertical manual
 */
const getVerticalCenteringMargin = (numberOfLines: number): number => {
  const contentHeight = numberOfLines * ESTIMATED_LINE_HEIGHT
  const remainingSpace = FIXED_CARD_HEIGHT - contentHeight
  // Retorna metade do espaço restante para usar como margem superior
  // Garante que não seja negativo
  return Math.max(0, remainingSpace / 2)
}

/**
 * Gera o conteúdo de uma célula (cartão) do PDF.
 * @param data Dados do plantão
 * @param hideStatusLabels Se true, oculta legendas
 */
export const getCard = (data: StationWeekList | undefined, hideStatusLabels: boolean): CardType => {
  // CORREÇÃO: Usando `as const` para o TS entender que não é apenas uma string aleatória
  const commonProps = {
    alignment: 'center' as Alignment
  }

  if (!data) return { text: '', style: 'emptyCard', ...commonProps } as TableCell

  // Ocupado sem identificação: nunca sai como "Vaga Aberta"; leva o responsável quando houver
  if (isUnidentifiedCoverage(data)) {
    const stack: ContentText[] = [
      { text: COVERAGE_STATUS_SHORT_LABELS[CoverageStatus.UNIDENTIFIED], bold: true, fontSize: 8 }
    ]
    if (data.coverageResponsibleName)
      stack.push({ text: data.coverageResponsibleName, fontSize: 7 })
    stack[0].margin = [0, getVerticalCenteringMargin(stack.length), 0, 0]
    return { stack, style: 'unidentifiedCard', ...commonProps }
  }

  if (data.opened) {
    const margin = getVerticalCenteringMargin(1)
    return {
      stack: [{ text: 'Vaga Aberta', margin: [0, margin, 0, 0] }],
      style: 'openedCard',
      ...commonProps
    }
  }

  const stackContent: any[] = []
  let lineCount = 0

  if (data.doctorName) {
    stackContent.push({ text: getFirstAndLastName(data.doctorName), bold: true, fontSize: 8 })
    lineCount++
  }

  if (data.crm) {
    stackContent.push({ text: data.crm, fontSize: 8 })
    lineCount++
  }

  if (!hideStatusLabels && data.doctorConfirmed === false) {
    stackContent.push({ text: 'Não Confirmado', style: 'legend', margin: [0, 2, 0, 0] })
    lineCount++
  }

  if (stackContent.length === 0) {
    return { text: '', style: getStyleClass(data.cell), ...commonProps }
  }

  // APLICAÇÃO DO CÁLCULO DE CENTRALIZAÇÃO
  // Calculamos a margem necessária com base no número de linhas e aplicamos APENAS no primeiro elemento
  const topMargin = getVerticalCenteringMargin(lineCount)

  // Ajuste fino: se tiver margin definida no primeiro item (ex: status sem nome), soma
  const firstItem = stackContent[0]
  firstItem.margin = [0, topMargin + getFirstItemTopMargin(firstItem.margin), 0, 0]

  return {
    stack: stackContent,
    style: getStyleClass(data.cell),
    ...commonProps
  }
}

const getMaxSlots = (position: any): number => {
  if (!position?.stations) return 1
  let max = 0
  position.stations.forEach((day: any[]) => {
    if (day?.length > max) max = day.length
  })
  return max > 0 ? max : 1
}

/**
 * Gera o corpo da tabela para todas as semanas.
 */
const getTableBody = (allWeekData: WeekData[], hideStatusLabels: boolean): Content[] => {
  const contents: Content[] = []

  allWeekData.forEach((weekData) => {
    const { responseData, weekStartDate } = weekData
    const response = responseData

    if (!response?.data || !response?.tableHead) return
    const dayOrder = ['Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado', 'Domingo']
    const mondayThisWeek = startOfWeek(new Date(weekStartDate), { weekStartsOn: 1 })

    const correctHeader = dayOrder.map((dayName, i) => {
      const date = addDays(mondayThisWeek, i)
      return {
        label: dayName,
        value: format(date, dateFormat)
      }
    })

    const apiHeaderWithOriginalIndex = response.tableHead.map((day, index) => ({
      ...day,
      originalIndex: index
    }))

    response.data.forEach((company) => {
      company.healthUnities.forEach((unit) => {
        unit.schedules.forEach((schedule) => {
          const tableRows: CardType[][] = []
          const columnCount = 3 + correctHeader.length

          schedule.shifts?.forEach((shift) => {
            shift.hours?.forEach((hour) => {
              hour.positions?.forEach((position) => {
                const maxSlots = getMaxSlots(position)
                for (let slotIndex = 0; slotIndex < maxSlots; slotIndex++) {
                  // CORREÇÃO: Adicionado `as any` aqui
                  const row: CardType[] = Array(columnCount).fill({
                    text: '',
                    style: 'emptyCard',
                    alignment: 'center' as Alignment,
                    verticalAlignment: 'middle' as const
                  })

                  // CORREÇÃO: Adicionado `as any` aqui nas 3 colunas
                  row[0] = {
                    text: shift.title || '',
                    style: 'tableCard',
                    verticalAlignment: 'middle' as const,
                    alignment: 'center' as Alignment
                  } as TableCell
                  row[1] = {
                    text: position.title || '',
                    style: 'tableCard',
                    verticalAlignment: 'middle',
                    alignment: 'center'
                  } as TableCell
                  row[2] = {
                    text: hour.title || '',
                    style: 'tableCard',
                    verticalAlignment: 'middle' as const,
                    alignment: 'center' as Alignment
                  } as TableCell

                  correctHeader.forEach((correctDay, correctIndex) => {
                    const apiDay = apiHeaderWithOriginalIndex.find(
                      (d) => d.value === correctDay.value
                    )
                    let stationData: StationWeekList | undefined = undefined
                    if (apiDay) {
                      stationData = position.stations?.[apiDay.originalIndex]?.[slotIndex]
                    }
                    row[3 + correctIndex] = getCard(stationData, hideStatusLabels)
                  })

                  tableRows.push(row)
                }
              })
            })
          })

          if (tableRows.length === 0) return

          const scheduleTitle = `${company.companyName} - ${unit.healthUnitName} | ${schedule.scheduleName.toUpperCase()}`

          const weeklyScheduleTable: Content = {
            margin: [0, 0, 0, 20],
            table: {
              widths: [60, 80, 60, ...Array(correctHeader.length).fill('*')],
              headerRows: 3,
              dontBreakRows: true,

              heights: (rowIndex) => {
                if (rowIndex < 3) return 15
                return FIXED_CARD_HEIGHT // Altura fixa (45)
              },

              body: [
                [
                  {
                    text: scheduleTitle,
                    style: 'header',
                    colSpan: columnCount,
                    fillColor: '#3ea2b7',
                    border: [true, true, true, false],
                    verticalAlignment: 'middle'
                  } as any, // Garantindo que não reclame aqui também
                  ...Array(columnCount - 1).fill({})
                ],
                [
                  {
                    text: 'Turno',
                    style: 'tableCard',
                    border: [true, false, true, true],
                    verticalAlignment: 'middle'
                  } as any,
                  {
                    text: 'Posição',
                    style: 'tableCard',
                    border: [true, false, true, true],
                    verticalAlignment: 'middle'
                  } as any,
                  {
                    text: 'Horário',
                    style: 'tableCard',
                    border: [true, false, true, true],
                    verticalAlignment: 'middle'
                  } as any,
                  ...correctHeader.map(
                    (th) =>
                      ({
                        text: th.label,
                        style: 'tableCard',
                        verticalAlignment: 'middle'
                      }) as any
                  )
                ],
                [
                  { text: '', style: 'tableCard', verticalAlignment: 'middle' } as any,
                  { text: '', style: 'tableCard', verticalAlignment: 'middle' } as any,
                  { text: '', style: 'tableCard', verticalAlignment: 'middle' } as any,
                  ...correctHeader.map(
                    (th) =>
                      ({
                        text: th.value,
                        style: 'tableCard',
                        verticalAlignment: 'middle'
                      }) as any
                  )
                ],
                ...tableRows
              ]
            }
          }
          contents.push(weeklyScheduleTable)
        })
      })
    })
  })

  return contents
}

export const getDocDefinition = (
  data: WeekData[],
  hideStatusLabels: boolean = false
): TDocumentDefinitions => {
  const docDefinition: TDocumentDefinitions = {
    pageOrientation: 'landscape',
    content: [
      { image: 'logoImg', width: 150, alignment: 'left', margin: [0, 0, 0, 20] },
      ...getTableBody(data, hideStatusLabels)
    ],
    styles: {
      openedCard: {
        bold: true,
        fontSize: 9,
        alignment: 'center',
        color: '#ffffff',
        fillColor: '#f09031',
        margin: [0, 0, 0, 0]
      },
      unidentifiedCard: {
        bold: true,
        fontSize: 9,
        alignment: 'center',
        color: UNIDENTIFIED_COVERAGE_COLORS.text,
        fillColor: UNIDENTIFIED_COVERAGE_COLORS.stripeDark,
        margin: [0, 0, 0, 0]
      },
      coverageCard: {
        bold: true,
        fontSize: 9,
        alignment: 'center',
        fillColor: '#e27896',
        color: '#ffffff',
        margin: [0, 0, 0, 0]
      },
      weeklyCard: {
        bold: true,
        fontSize: 9,
        alignment: 'center',
        fillColor: '#85c8d6',
        color: '#ffffff',
        margin: [0, 0, 0, 0]
      },
      extraCard: {
        bold: true,
        fontSize: 9,
        alignment: 'center',
        fillColor: '#a5d6a7',
        color: '#ffffff',
        margin: [0, 0, 0, 0]
      },
      pendingCard: {
        bold: true,
        fontSize: 9,
        alignment: 'center',
        color: '#ffffff',
        fillColor: '#bcbccc',
        margin: [0, 0, 0, 0]
      },
      hoursCard: {
        bold: true,
        fontSize: 9,
        alignment: 'center',
        fillColor: '#ffffff',
        color: '#2c3e4f',
        margin: [0, 5, 0, 5]
      },
      tableCard: {
        bold: true,
        fontSize: 8,
        alignment: 'center',
        fillColor: '#f3f4f6',
        color: '#2c3e4f',
        margin: [2, 5, 2, 5]
      },
      emptyCard: { fillColor: '#e5e7eb' },
      defaultCard: {
        bold: true,
        fontSize: 9,
        alignment: 'center',
        fillColor: 'grey',
        color: '#fcc200',
        margin: [0, 0, 0, 0]
      },
      legend: { color: '#ff0000', fontSize: 7, bold: true },
      header: {
        bold: true,
        fontSize: 10,
        alignment: 'center',
        fillColor: '#3ea2b7',
        color: '#ffffff'
      }
    },
    watermark: {
      text: 'Minha Escala',
      fontSize: 72,
      color: '#6d4c41',
      opacity: 0.075,
      angle: -55,
      bold: true,
      italics: false
    },
    images: { logoImg: img64 },
    footer: function (currentPage, pageCount) {
      return {
        columns: [
          {
            stack: [
              {
                text: `Minha Escala © ${new Date().getFullYear()}`,
                margin: [40, 20, 0, 0],
                fontSize: 8,
                color: '#404040'
              }
            ],
            width: '*'
          },
          {
            stack: [
              {
                text: new Date().toLocaleDateString('pt-BR', {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric'
                }),
                margin: [0, 20, 0, 0],
                fontSize: 8,
                color: '#404040',
                alignment: 'center'
              }
            ],
            width: '*'
          },
          {
            stack: [
              {
                text: `Página ${currentPage} de ${pageCount}`,
                margin: [0, 20, 40, 0],
                fontSize: 8,
                color: '#404040',
                alignment: 'right'
              }
            ],
            width: '*'
          }
        ]
      }
    },
    defaultStyle: { alignment: 'center', fontSize: 8 }
  }
  return docDefinition
}

export const getWeeksBetweenDates = (
  start: Date,
  end: Date
): { startDate: string; endDate: string; weekStartDate: string }[] => {
  const weeks: { startDate: string; endDate: string; weekStartDate: string }[] = []
  let current = new Date(start)
  while (current <= end) {
    const weekStart = startOfWeek(current, { weekStartsOn: 1 })
    const weekEnd = endOfWeek(current, { weekStartsOn: 1 })

    weeks.push({
      startDate: weekStart.toISOString(),
      endDate: weekEnd.toISOString(),
      weekStartDate: weekStart.toISOString()
    })
    current = addDays(weekEnd, 1)
  }
  return weeks
}
